export const tableHeader = [
  {
    id: 'name',
    type: 'text',
    value: 'Nome',
  },
  {
    id: 'active',
    type: 'boolean',
    value: 'Ativo',
  },
  {
    id: 'action',
    type: 'actions',
    value: '',
  },
]
